const heatCapWaterJoules = 4180;
const joulesPerKWh = 3600000;
export const heatCapWaterKWh = heatCapWaterJoules / joulesPerKWh;

export const daysInAYear = 365;
